import { atom } from "jotai";

export const listRoleAtom = atom<any[] | []>([]);
